import { gql } from "@apollo/client";

export const CLAIM_ORGANIZATION = gql`
  mutation ClaimOrganization($data: ClaimData) {
    claimOrganization(data: $data)
  }
`;
